import { productIdFormat, supplierIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const getSupplierProductCosts = {
  name: "getSupplierProductCosts" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    productIds: z.array(productIdFormat.schema),
  }),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        image: z.string().nullable(),
        unitCost: z.number().nullable(),
        currency: z.string(),
      }),
    ),
  }),
};
